import { useState, useEffect } from 'react';
import api from '../../lib/api';
import { Gauge } from 'lucide-react';

/** Sticky banner shown only when the client's monthly voice-minutes limit is
 * exceeded — mirrors the ImpersonationBanner visual pattern in EliosLayout. */
export function UsageLimitBanner() {
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/elios-client/usage')
      .then((r) => { if (!cancelled) setUsage(r.data); })
      .catch(() => {}); // non-elios-client users (admin browsing) or no data yet — banner just stays hidden
    return () => { cancelled = true; };
  }, []);

  if (!usage?.voice_minutes_exceeded) return null;

  return (
    <div
      className="fixed top-3 left-1/2 -translate-x-1/2 z-[65] bg-amber-500 text-white px-3 sm:px-4 py-1.5 sm:py-2 flex items-center gap-2 sm:gap-3 text-xs sm:text-sm shadow-lg rounded-full max-w-[calc(100%-1.5rem)]"
      data-testid="usage-limit-banner"
    >
      <Gauge className="w-4 h-4 shrink-0" />
      <span className="truncate min-w-0">
        Hai superato il limite di <strong>{usage.voice_minutes_limit} min</strong> inclusi
        <span className="hidden sm:inline">
          {' '}— extra: <strong>{usage.voice_extra_minutes} min</strong>, costo stimato{' '}
          <strong>€{usage.voice_extra_cost_eur.toFixed(2)}</strong>
        </span>
      </span>
    </div>
  );
}

export default UsageLimitBanner;
